import Page from '@cinch/oxd-pages/guides/src'
import { Env, getEnv } from '@cinch/oxd-utils/env/src'
import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import SEO, { Breadcrumb } from '../components/seo'

interface GuidesPage extends Cinch.SitePage {
  navigate: (path: string) => void
  pageContext: {
    isCreatedByStatefulCreatePages: boolean
    items: any[]
    totalItemsCount: number
    activePage: number
    itemsCountPerPage: number
  }
}

const Guides: React.FC<GuidesPage> = ({ location, pageContext, navigate }) => {
  const { items, totalItemsCount, activePage, itemsCountPerPage } = pageContext
  const data: any = useStaticQuery(graphql`
    query GuidesTranslationQuery {
      allTranslations {
        edges {
          node {
            guides {
              title
              searchPlaceholder
            }
          }
        }
      }
    }
  `)

  const translations = data.allTranslations.edges[0].node.guides

  const breadcrumbs: Breadcrumb[] = []

  if (location) {
    const pageUrl = `${getEnv(Env.SiteUrl)}${location.pathname}`
    breadcrumbs.push(
      ...[
        {
          item: `${getEnv(Env.SiteUrl)}/guides`,
          name: 'How-to guides',
        },
        ...(pageContext.activePage > 1 ? [{ item: pageUrl, name: `Page ${activePage}` }] : []),
      ],
    )
  }

  return (
    <>
      <SEO title={translations.title} breadcrumbs={breadcrumbs} />
      <Page
        i18n={translations}
        items={items}
        pagination={{
          totalItemsCount,
          activePage,
          itemsCountPerPage,
          getPageUrl: (page) => (page > 1 ? `/guides/${page}` : '/guides'),
          onChange: (page) => navigate(page > 1 ? `/guides/${page}` : `/guides`),
        }}
      />
    </>
  )
}

export default Guides
